import { Component, OnInit } from '@angular/core';
import { AuthService, FormErrors } from '../login/auth.service';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import { ContactService, ContactData } from './contact.service'; 
import { Router } from '@angular/router';

@Component({
  selector: 'page-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  providers: [ContactService]
})
export class ContactPage implements OnInit {

  public contactForm: ContactForm = new ContactForm;
  public processing: boolean = false;

  constructor(private authService: AuthService, private toastyService:ToastyService, private contactService: ContactService, private router: Router,) {
      let auth = this.authService.getAuth();
      if (auth.isAuthorized()) {
        this.contactForm.data.firstName = auth.firstName;
        this.contactForm.data.lastName = auth.lastName;
        this.contactForm.data.email = auth.email;
      }
  }

  ngOnInit() {

  }

  public onSubmit() {
      if (this.contactForm.validate()) {
          this.processing = true;
          this.contactService.send(this.contactForm.data).then(
            result => {
              let toastOptions:ToastOptions = {
                  title: null,
                  msg: "Thank you for your email. We will get back to you as soon as possible.",
                  showClose: true,
                  timeout: 5000,
                  theme: "bootstrap"
              };
              this.toastyService.success(toastOptions);
              setTimeout(() =>{
               this.router.navigate(['dashboard']);
              }, 1000);
            }, 
            err => {
              this.processing = false;
              let toastOptions:ToastOptions = {
                  title: null,
                  msg: "Please fill all necessary fields correctly!",
                  showClose: true,
                  timeout: 5000,
                  theme: "bootstrap"
              };
              this.toastyService.error(toastOptions);
              this.contactForm.errors.list = err.json().errors;
            }
          );
    }
  }
}


class ContactForm {
  public data: ContactData = new ContactData;
  public notValid: boolean = true;
  public errors: FormErrors = new FormErrors;

  private isEmpty(str: string): boolean {
    return str.replace(/\s/g,'') == "";
  }

   private isEmail(str: string): boolean {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str);
  }
  public validate(): boolean {
    this.errors.clear();
    if (this.isEmpty(this.data.firstName)) {
      this.errors.add({field: 'firstName', type: 'required'});
    }

    if (this.isEmpty(this.data.lastName)) {
      this.errors.add({field: 'lastName', type: 'required'});
    }

    if (this.isEmpty(this.data.message)) {
      this.errors.add({field: 'message', type: 'required'});
    }

    if (this.isEmpty(this.data.email)) {
      this.errors.add({field: 'email', type: 'required'});
    } else {
      if (!this.isEmail(this.data.email)) {
        this.errors.add({field: 'email', type: 'email'});
      }
    }

    this.notValid = !this.errors.isEmpty();
    return !this.notValid;
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/contact/contact.component.ts